import { SVGProps } from 'react';

const SvgProjects = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 12" {...props}>
        <path d="M12.833 1.333A1.167 1.167 0 0 1 14 2.5v5.833A1.167 1.167 0 0 1 12.833 9.5H3.5a1.167 1.167 0 0 1-1.167-1.167v-7A1.167 1.167 0 0 1 3.5.167H7l1.167 1.166h4.666ZM1.167 2.5v8.167h10.5v1.166h-10.5A1.167 1.167 0 0 1 0 10.667V2.5h1.167Zm2.333 0v5.833h9.333V2.5H3.5Z" />
    </svg>
);
export default SvgProjects;
